//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.Feature.js";
import "../no/ugmath.js";
let d=[[[0,"Height",0,0],[0,"ImageFileName",0,0],[0,"Length",0,0],[0,"Matrix",0,0],[0,"MaximumTextureSize",0,0],[0,"Origin",0,0],[0,"Translucency",0,0]],[[["origin","matrix","length","height","image_file_name","translucency","maximum_texture_size"],"Update",{},7,0]],[]];
SPLM.Features.RasterImage = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.RasterImage";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.RasterImage.MaxTextureSize = Object.freeze({
    "N512" : "N512", "N1024" : "N1024", "N2048" : "N2048", "N4096" : "N4096", "N8192" : "N8192", "N16384" : "N16384", "N32768" : "N32768"});

export default SPLM;